import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import SearchNavLink from "./SearchNavLink";

const style = {
  btn: {
    backgroundColor: "#323A45",
    border: "none",
    color: "white",
    padding: "8px 20px",
    textAlign: "center",
    textDecoration: "none",
    display: "inline-block",
    fontSize: "16px",
    marginLeft: "4px"
  }
};

class SearchTypeNavigation extends Component {
  render() {
    return (
      <div>
        <SearchNavLink to="/search" name="Handlers" />
        <SearchNavLink
          to="/search/transporter"
          name="Transporter Registration"
        />
        <SearchNavLink to="/search-manifests" name="Manifest" />
      </div>
    );
  }
}

export default withRouter(SearchTypeNavigation);
